import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactHealthMetrics = () => {
  const metrics = [
    {
      id: 1,
      label: "Total Contacts",
      value: "12,847",
      change: "+8.2%",
      trend: "up",
      icon: "Users",
      color: "var(--color-primary)",
      description: "Contacts actifs dans la base"
    },
    {
      id: 2,
      label: "Score d\'engagement",
      value: "78.5",
      change: "+5.3%",
      trend: "up",
      icon: "TrendingUp",
      color: "var(--color-success)",
      description: "Score moyen d\'engagement"
    },
    {
      id: 3,
      label: "Fréquence d\'interaction",
      value: "4.2/mois",
      change: "-2.1%",
      trend: "down",
      icon: "Activity",
      color: "var(--color-secondary)",
      description: "Interactions moyennes par contact"
    },
    {
      id: 4,
      label: "Complétude des données",
      value: "92.3%",
      change: "+3.7%",
      trend: "up",
      icon: "CheckCircle",
      color: "var(--color-success)",
      description: "Profils avec données complètes"
    },
    {
      id: 5,
      label: "Doublons détectés",
      value: "247",
      change: "-12.5%",
      trend: "up",
      icon: "AlertTriangle",
      color: "var(--color-warning)",
      description: "Contacts en double potentiels"
    },
    {
      id: 6,
      label: "Croissance mensuelle",
      value: "+1,053",
      change: "+15.8%",
      trend: "up",
      icon: "ArrowUpRight",
      color: "var(--color-accent)",
      description: "Nouveaux contacts ce mois"
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
      {metrics?.map((metric) => (
        <div
          key={metric?.id}
          className="bg-card rounded-lg p-4 md:p-6 shadow-elevation-2 hover:shadow-elevation-3 transition-smooth"
        >
          <div className="flex items-start justify-between mb-3 md:mb-4">
            <div className="flex items-center gap-3">
              <div
                className="w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center"
                style={{ backgroundColor: `${metric?.color}15` }}
              >
                <Icon name={metric?.icon} size={20} color={metric?.color} />
              </div>
              <div>
                <p className="text-xs md:text-sm text-muted-foreground mb-1">
                  {metric?.label}
                </p>
                <h3 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground">
                  {metric?.value}
                </h3>
              </div>
            </div>
          </div>
          
          <div className="flex items-center justify-between">
            <p className="text-xs md:text-sm text-muted-foreground line-clamp-1">
              {metric?.description}
            </p>
            <div className={`flex items-center gap-1 px-2 py-1 rounded-md ${
              metric?.trend === 'up' ?'bg-success/10 text-success' :'bg-error/10 text-error'
            }`}>
              <Icon 
                name={metric?.trend === 'up' ? 'TrendingUp' : 'TrendingDown'} 
                size={14} 
              />
              <span className="text-xs font-medium whitespace-nowrap">
                {metric?.change}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ContactHealthMetrics;